import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  canDoFoYouContainer: {},
  canDoFoYouTitle: {
    textAlign: "center",
    color: "#FFFFFF",
    marginBottom: 64,
    "@media (max-width: 1200px)": {
      textAlign: "left"
    },
    "@media (max-width: 600px)": {
      marginBottom: 40
    }
  },
  canDoFoYouCardsContainer: {
    display: "flex",
    flexWrap: "wrap",
    marginLeft: -12,
    marginRight: -12
  },
  canDoFoYouCardItem: {
    paddingLeft: 12,
    paddingRight: 12,
    marginBottom: 24,
    width: "25%",
    "&:hover": {
      "& img": {
        transform: "scale(1.2)"
      }
    },
    "& img": {
      borderRadius: "8px 8px 0 0",
      transition: "transform .5s !important"
    },
    "@media (max-width: 1200px)": {
      width: "50%"
    },
    "@media (max-width: 600px)": {
      width: "100%",
      marginBottom: 16
    }
  },
  canDoFoYouLogosWrapper: {
    textAlign: "center",
    color: "#FFFFFF",
    marginTop: 96,
    "@media (max-width: 600px)": {
      display: "none"
    }
  },
  canDoFoYouLogosTitle: {},
  canDoFoYouLogosSubTitle: {
    fontStyle: "italic",
    fontSize: 24,
    fontWeight: 600
  },
  canDoFoYouLogosItems: {
    marginTop: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  canDoFoYouLogosItem: {
    backgroundColor: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 80,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.05)",
    padding: 10,
    borderRadius: 5,
    minWidth: 160,
    marginLeft: 12,
    marginRight: 12,
    pointerEvents: "none"
  },
  canDoFoYouLogosItemLg: {
    minWidth: 220
  },
  hidden: {
    "@media (max-width: 600px)": {
      display: "none"
    }
  },
  canDoFoYouLoadMore: {
    display: "none",
    marginTop: 24,
    marginLeft: "auto",
    marginRight: "auto",
    backgroundColor: "transparent",
    border: "none",
    color: "#FFFFFF",
    fontSize: 15,
    fontWeight: 600,
    fontFamily: "Montserrat, sans-serif",
    alignItems: "center",
    "&:after": {
      content: "''",
      width: 24,
      height: 24,
      display: "inline-block",
      marginLeft: 8,
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 10L11.9293 14.9293C11.9683 14.9683 12.0317 14.9683 12.0707 14.9293L17 10' stroke='white' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E%0A\")"
    },
    "@media (max-width: 600px)": {
      display: "flex"
    }
  }
});
